var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3792 31.8567V13.7355H4.35605V31.8567H10.3792ZM7.3676 11.2614C9.46799 11.2614 10.7753 9.86987 10.7753 8.13089C10.7362 6.35277 9.46799 4.99987 7.40744 4.99987C5.34711 4.99987 4 6.35277 4 8.13089C4 9.86987 5.30704 11.2614 7.32834 11.2614H7.3676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7119 31.8567H19.735V21.7371C19.735 21.1955 19.7741 20.6544 19.9332 20.2673C20.3686 19.1852 21.3597 18.0645 23.0236 18.0645C25.2031 18.0645 26.0749 19.7262 26.0749 22.1623V31.8567H32.0975V21.4663C32.0975 15.9003 29.126 13.3103 25.1633 13.3103C21.914 13.3103 20.4875 15.1265 19.6949 16.3636H19.7352V13.7355H13.7121C13.7911 15.4359 13.7119 31.8567 13.7119 31.8567Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7e177bcf608b72643ece8060f7ee3f11.svg";
export { ForwardRef as ReactComponent };